<span *ngIf="!required" class="sc-ds-text-field optional"> (Optional)</span>
<ds-date-field
  debounce-time="150"
  required="{{ required }}"
  [formControl]="formControl"
  [formlyAttributes]="field"
  heading="{{ label }}"
  [invalid]="invalid"
></ds-date-field>
